export default __webpack_public_path__ + "static/media/downWhite.8df9f2c8.svg";